import { render, staticRenderFns } from "./EcommerceRecordReport.vue?vue&type=template&id=409945b4"
import script from "./EcommerceRecordReport.vue?vue&type=script&lang=js"
export * from "./EcommerceRecordReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports